module.exports = __webpack_public_path__ + "f180fc9ee1459180f0f52b7f2e235738.svg";